

export const environment = {
    production: false,
    hideConsole: false,
    recaptchaSiteKey: '6LeyKcUkAAAAAKLVRsKUR-qwYH_wpH5JQqRtu2Ox',

    mode: 'Dev'
};